export default __webpack_public_path__ + "static/benifitImg-e44005a4e6e090867871185ca656847e.png";